import { createSlice } from "@reduxjs/toolkit";
import initialState from "../../configs/redux/initialState";

// IMPORTANT: Note that with @reduxjs/toolkit, you can change state directly.

const appReducer = createSlice({
  name: "app",
  initialState: {
    ...initialState.appReducer,
    share: null,
  },
  reducers: {
    showLoading(state, action) {
      state.loading = true;
    },
    hideLoading(state, action) {
      state.loading = false;
    },
    setUser(state, action) {
      const incoming = action.payload;
      if (!incoming) return;
      // Preserve live stats fields (message_sent, message_limit, point) that only
      // come from getWhatYouNeed. A plain getUser call won't include them, so we
      // merge instead of replace to avoid wiping data already in the store.
      const STATS_FIELDS = ['message_sent', 'message_limit', 'point', 'package_name'];
      const merged = { ...state.user, ...incoming };
      STATS_FIELDS.forEach((key) => {
        if (incoming[key] === undefined && state.user[key] !== undefined) {
          merged[key] = state.user[key];
        }
      });
      state.user = merged;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setShare(state, action) {
      state.share = action.payload;
    },
  },
});

export const { showLoading, hideLoading, setUser, setLoading, setShare } =
  appReducer.actions;

export default appReducer.reducer;
